import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
export const RecommendedLabel = () => {
  return /*#__PURE__*/_jsx(Badge, {
    blockSize: "12px",
    borderRadius: "100",
    insetBlockStart: "-1px",
    insetInlineStart: "-1px",
    position: "absolute",
    use: "calypso",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'button.recommended'
    })
  });
};